export default __webpack_public_path__ + "static/media/MANTA.100a0df7.png";